import { render } from "./addChampionship-step1.vue?vue&type=template&id=53994540&scoped=true"
import script from "./addChampionship-step1.vue?vue&type=script&lang=js"
export * from "./addChampionship-step1.vue?vue&type=script&lang=js"

import "./addChampionship-step1.vue?vue&type=style&index=0&id=53994540&scoped=true&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53994540"]])

export default __exports__